import { eventBus } from '../eventBus.js';
import { Control } from 'ol/control.js';

export const table = {

  /**
   * Dom id of the table element.
   * @type {String}
   * @private
   */
  _cssClass: 'result-table__content',

  /**
   * @type {HTMLDivElement}
   */
  domNode: null,

  /**
   * CSS class for the visible state.
   * @type {String}
   * @private
   */
  _cssClassVisible: 'result-table__content_visible',

  /**
   * @type {ol/Control}
   */
  control: null,

  /**
   * Initialize the result table.
   * @param {String} tableHTML
   */
  init (tableHTML) {
    this._initEvents();
    this.domNode = document.querySelector('.' + this._cssClass);
    this.domNode.innerHTML = tableHTML;
    this.control = this._get();
    return this;
  },

  _get () {
    return new Control({
      element: document.getElementById('result-table')
    });
  },

  /**
   * Initialize the events.
   * @listens eventBus~event:toggleTable
   * @returns {void}
   * @private
   */
  _initEvents () {
    eventBus.add('toggleTable', this._toggleTable.bind(this));
  },

  /**
   * Show or hide the result table.
   * @returns {void}
   * @private
   */
  _toggleTable () {
    this.domNode.classList.toggle(this._cssClassVisible);
  }
};